import React, {Component, useState} from 'react';
//import aiml from './images/aiml.png';
import Jobs from './careersApi';
//import { jobsdata } from 'jquery';
import JobDetails from './jobDetails'




function FadeInSection(props) {
    
    const [isVisible, setVisible] = React.useState(false);
    const domRef = React.useRef();
    React.useEffect(() => {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => setVisible(entry.isIntersecting));
      });
      observer.observe(domRef.current);
    }, []);
    return (
      <div
        className={`fade-in-section ${isVisible ? 'is-visible' : ''}`}
        ref={domRef}
      >
        {props.children}
      </div>
    );
  }


// class Careers extends Component
const Careers = () =>{
    const [jobsdata, setjobsdata] = useState(Jobs);
    // const [show, setshow] = useState(false);

        return(
            <div className="container-fluid servicepage">
                <div className="row careerheader">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                       {/* <h1></h1>*/}
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 sectionheading">
                        <h2>Career @ CollabDots</h2>
                        <p>
                        </p>
                    </div>                            
                </div>
                <div className="row">
                    <div className="container">
                      <div className="row mb-5">
                          {
                              jobsdata.map((curElem ) => {
                                  const {id, description, image, Expereance, Email, Designation} = curElem;
                                  return ( 
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">                        
                                      <JobDetails key={id} {...curElem} />  
                                    </div>                  
                                  );
                              })
                          }
                      </div>
                      <div className="row mb-5">
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                          <h4> Send your resumes: info@collabdots.com  or 7008587101</h4>
                          </div>
                      </div>
                    </div>                     
                        
                </div>              

            </div>            
        );
 
}

export default Careers;